"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import SafeImage from "@/components/common/SafeImage";
import { sectionBgStyle } from "../section-style";
type SlideshowSectionData = Extract<CampaignPageSection, {
  type: "slideshow";
}>;

/** Carousel auto-putar — beda dari 'gallery' (grid statis semua foto sekaligus). */
export default function SlideshowSection(t0) {
  const $ = _c(24);
  const {
    section
  } = t0;
  let t1;
  if ($[0] !== section.slides) {
    t1 = section.slides ?? [];
    $[0] = section.slides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slides = t1;
  const [index, setIndex] = useState(0);
  let t2;
  let t3;
  if ($[2] !== section.interval_ms || $[3] !== slides.length) {
    t2 = () => {
      if (slides.length <= 1) {
        return;
      }
      const timer = setInterval(() => setIndex(i => (i + 1) % slides.length), section.interval_ms);
      return () => clearInterval(timer);
    };
    t3 = [slides.length, section.interval_ms];
    $[2] = section.interval_ms;
    $[3] = slides.length;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (slides.length === 0) {
    return null;
  }
  const current = slides[index];
  let t4;
  if ($[6] !== section.custom_style) {
    t4 = sectionBgStyle(section.custom_style);
    $[6] = section.custom_style;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = current.caption ?? "";
  let t6;
  if ($[8] !== current.url || $[9] !== index || $[10] !== t5) {
    t6 = <SafeImage key={index} src={current.url} alt={t5} loading="eager" className="aspect-[16/9] w-full object-cover" />;
    $[8] = current.url;
    $[9] = index;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== current.caption) {
    t7 = current.caption && <p className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent px-4 py-3 text-sm text-white">{current.caption}</p>;
    $[12] = current.caption;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== index || $[15] !== slides) {
    t8 = slides.length > 1 && <><button type="button" onClick={() => setIndex(i_0 => (i_0 - 1 + slides.length) % slides.length)} aria-label="Slide sebelumnya" className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-warm-black opacity-0 shadow-sm transition-opacity group-hover:opacity-100"><ChevronLeft className="h-5 w-5" /></button><button type="button" onClick={() => setIndex(i_1 => (i_1 + 1) % slides.length)} aria-label="Slide berikutnya" className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-warm-black opacity-0 shadow-sm transition-opacity group-hover:opacity-100"><ChevronRight className="h-5 w-5" /></button><div className="absolute inset-x-0 bottom-2 flex items-center justify-center gap-1.5">{slides.map((_, i_2) => <button key={i_2} type="button" onClick={() => setIndex(i_2)} aria-label={`Ke slide ${i_2 + 1}`} aria-current={i_2 === index} className={`h-1.5 rounded-full transition-all ${i_2 === index ? "w-5 bg-white" : "w-1.5 bg-white/60"}`} />)}</div></>;
    $[14] = index;
    $[15] = slides;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className="mx-auto max-w-3xl px-5"><div className="group relative overflow-hidden rounded-2xl border border-black/[0.06] bg-warm-cream/40">{t6}{t7}{t8}</div></div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t4 || $[22] !== t9) {
    t10 = <section className="bg-white py-10 md:py-14" style={t4}>{t9}</section>;
    $[21] = t4;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}